import { render, staticRenderFns } from "./SendDocumentsReportPreviewTable.vue?vue&type=template&id=7b573dff&scoped=true&lang=pug"
import script from "./SendDocumentsReportPreviewTable.vue?vue&type=script&lang=ts"
export * from "./SendDocumentsReportPreviewTable.vue?vue&type=script&lang=ts"
import style0 from "./SendDocumentsReportPreviewTable.vue?vue&type=style&index=0&id=7b573dff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b573dff",
  null
  
)

export default component.exports